import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Competition, EventType, PaginatedData, Tournament } from '../../@types';
import { QUERY_KEYS } from '../../constants';
import { getData } from '../../utils/api';

type UseCompetitionsAccordionProps = {
  competition: Competition;
  eventType: EventType;
};

export const useCompetitionsAccordion = ({ competition, eventType }: UseCompetitionsAccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  const { data: tournamentsData, isPending } = useQuery({
    queryKey: [QUERY_KEYS.tournaments, competition.id, eventType],
    queryFn: (): Promise<PaginatedData<Tournament>> =>
      getData('tournaments/with-events', {
        sportId: competition.sportId,
        competitionId: competition.id,
        type: eventType,
        checkOutcomes: false,
      }),
    enabled: expanded,
  });

  const toggleExpanded = () => setExpanded((prev) => !prev);
  const isLoadingTournaments = expanded && isPending;

  return {
    expanded,
    isLoading: isLoadingTournaments,
    tournaments: tournamentsData?.items ?? [],
    toggleExpanded,
    isExpanded: expanded && !isLoadingTournaments,
  };
};
